export const WAITING_PAGE_STEPS = {
  FETCHING_PERSONAL_DATA: 'FETCHING_PERSONAL_DATA',
  CHECKING_COVERAGE: 'CHECKING_COVERAGE',
  CHECKING_CONFIGURATION: 'CHECKING_CONFIGURATION',
  CHECKING_COMPATIBILITY: 'CHECKING_COMPATIBILITY',
  CONFIGURING_SERVICES: 'CONFIGURING_SERVICES',
  IDENTIFYING_PAYMENT_METHOD: 'IDENTIFYING_PAYMENT_METHOD',
  CALCULATING_OFFER: 'CALCULATING_OFFER',
  CREATING_ORDER: 'CREATING_ORDER',
  CREATING_AGREEMENT: 'CREATING_AGREEMENT',
  FLYING_PARROT: 'FLYING_PARROT',
  WINDMILL: 'WINDMILL',
};

export const ANIMATION_RENDER = {
  FLYING_PARROT: 'FLYING_PARROT',
  RIDER: 'RIDER',
  WINDMILL: 'WINDMILL',
  M_MOVISTAR: 'M_MOVISTAR',
  BOUNCING_LOGO: 'BOUNCING_LOGO',
};
